import { FC } from "react"
import { ExclamationCircleIcon } from "@heroicons/react/20/solid"

export type OutputDisplayProps = {
  /**
   * Response data to display
   */
  response: any
  /**
   * Function to call when reset button is clicked
   */
  resetFunction?: () => void
}

export const OutputDisplay: FC<OutputDisplayProps> = ({ response, resetFunction = () => {} }) => {
  return (
    <>
      {!response?.response_data && (
        <div className="p-4">
          <ExclamationCircleIcon className="h-6 w-6 my-4 text-yellow-400 mx-auto" />
          <p className="text-center font-bold">Please complete all fields before calculating coverage details.</p>
        </div>
      )}
      <div className="flex flex-col lg:flex-row">
        <div className="w-full">
          <div className="py-4 rounded bg-form-medium text-center lg:w-full">
            <p className="text-sm font-normal">Contract Asset Charge (CAC)</p>
            <p className="mt-1 text-xl font-bold">
              {!response?.response_data
                ? "-"
                : (response?.response_data?.outputs?.["0_CAC_Adj"] * 100).toFixed(2) + " %"}
            </p>
          </div>

          <div className="mt-2 py-4 rounded bg-form-medium text-center lg:w-full">
            <p className="text-sm font-normal">Internal Rate of Return (IRR)</p>
            <p className="mt-1 text-xl font-bold">
              {!response?.response_data ? "-" : (response?.response_data?.outputs?.["1_IRR"] * 100).toFixed(2) + " %"}
            </p>
          </div>

          <div className="mt-2 py-4 rounded bg-form-medium text-center lg:w-full">
            <p className="text-sm font-normal">Break Even Year</p>
            <p className="mt-1 text-xl font-bold">
              {!response?.response_data ? "-" : response?.response_data?.outputs?.["2_Breakeven_Yrs"]}
            </p>
          </div>
        </div>
      </div>

      {response && (
        <button
          className="flex justify-center items-center h-12 w-full bg-brand-light text-white rounded mt-2 font-semibold mt-6"
          onClick={resetFunction}
        >
          NEW QUOTE
        </button>
      )}
    </>
  )
}

